import { render, staticRenderFns } from "./BzInfo.vue?vue&type=template&id=545857de"
import script from "./BzInfo.vue?vue&type=script&lang=js"
export * from "./BzInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports